import React from 'react';
import {
  Box,
  Grid,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';

export const OvertimeTable = ({ tableData, headerItems }) => {
  return (
    <>
      {tableData.map((it, idx) => {
        const splittedLines = it[1].reduce((acc, item) => {
          if (!acc[item.pay_code]) {
            acc[item.pay_code] = [];
          }
          acc[item.pay_code].push(item);
          return acc;
        }, {});
        const splittedArr = Object.entries(splittedLines);
        return (
          <Box key={`section-${idx}`}>
            <Grid container spacing={3} className="my-2">
              <Grid item xs={12}>
                <Typography variant="h6" mt={3} mb={1}>
                  {it[0]}
                </Typography>
              </Grid>
              {splittedArr.map(([payCode, items], payIdx) => (
                <Grid item xs={12} key={`paycode-${payIdx}`}>
                  <TableContainer component={Paper} sx={{ overflowX: 'auto' }}>
                    <Table stickyHeader sx={{ minWidth: 650, tableLayout: 'auto' }} aria-label="overtime table">
                      <TableHead>
                        <TableRow>
                          {headerItems.map((it, hIdx) => (
                            <TableCell key={`head-${hIdx}`} sx={{ whiteSpace: 'nowrap' }}>{it[1]}</TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {items.map((item, i) => (
                          <TableRow
                            key={`row-${i}`}
                            sx={{
                              '&:last-child td, &:last-child th': {
                                border: 0,
                              },
                            }}
                          >
                            {headerItems.map((hi, indx) => (
                              <TableCell
                                key={`cell-${i}-${indx}`}
                                component={!indx ? 'th' : 'td'}
                                align="left"
                                scope="row"
                                sx={{ whiteSpace: 'nowrap' }}
                              >
                                <Typography
                                  fontSize={14}
                                  fontWeight={500}
                                  color={
                                    item[hi[0]] === 'Filled'
                                      ? 'green'
                                      : item[hi[0]] === 'Ordered'
                                      ? 'red'
                                      : 'black'
                                  }
                                >
                                  {item[hi[0]]}
                                </Typography>
                              </TableCell>
                            ))}
                          </TableRow>
                        ))}
                        <TableRow
                          key={`total-${payIdx}`}
                          sx={{
                            '&:last-child td, &:last-child th': {
                              border: 0,
                            },
                          }}
                        >
                          {headerItems.map((hi, indx) => {
                            const fieldData = items.reduce((acc, item) => {
                              const val = +item[hi[0]];
                              return !Number.isNaN(val) ? acc + val : acc;
                            }, 0);
                            return (
                              <TableCell
                                key={`sum-${payIdx}-${indx}`}
                                component={!indx ? 'th' : 'td'}
                                align="left"
                                scope="row"
                              >
                                <Typography fontSize={14} fontWeight={600}>
                                  {hi[0] === 'hours' || hi[0] === 'amount'
                                    ? +fieldData.toFixed(2)
                                    : ''}
                                </Typography>
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
              ))}
            </Grid>
          </Box>
        );
      })}
    </>
  );
};
